import React, { useEffect } from "react";
import { useSelector } from "react-redux";

// Goes inside MapOverlays
const PrintBoxOverlay = () => {
    const overlayStyle = useSelector((state) => state.toolSelect.printBox);
    return (
        overlayStyle && (
            <span
                style={{
                    zIndex: -1,
                    position: "fixed",
                    top: overlayStyle.top - 2,
                    left: overlayStyle.left - 2,
                    width: overlayStyle.width + 1,
                    height: overlayStyle.height + 1,
                    backgroundColor: "rgba(255,0,0,.1)",
                    paddingBottom: "2px",
                    paddingRight: "2px",
                    borderStyle: "dashed",
                    borderColor: "red",
                    pointerEvents: "none",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                }}>
                <span
                    style={{
                        width: 0,
                        height: 0,
                        borderRadius: "50%",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        borderColor: "grey",
                    }}
                />
            </span>
        )
    );
};

export default PrintBoxOverlay;
